import { useQuery } from "@tanstack/react-query";
import { cfDashboardApi } from "./client";
import type { CfDashboardRangeParams } from "./types";

export const cfDashboardKeys = {
  all: ["cf-dashboard"] as const,
  summary: (params: CfDashboardRangeParams) =>
    [...cfDashboardKeys.all, "summary", params] as const,
};

export function useCfDashboardSummary(params: CfDashboardRangeParams) {
  return useQuery({
    queryKey: cfDashboardKeys.summary(params),
    queryFn: () => cfDashboardApi.summary(params),
  });
}
